import { RefiTrackPageview } from './track-pageview.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';

defineRefiElement('refi-track-pageview', RefiTrackPageview);
